import createIcon from '../../createIcon';

/**
 * @component @name Hevc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41IDExSDQuNVY5SDNWMTVINC41VjEyLjVINS41VjE1SDdWOUg1LjVWMTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEgMTFWMTBDMjEgOS40NSAyMC41NSA5IDIwIDlIMThDMTcuNDUgOSAxNyA5LjQ1IDE3IDEwVjE0QzE3IDE0LjU1IDE3LjQ1IDE1IDE4IDE1SDIwQzIwLjU1IDE1IDIxIDE0LjU1IDIxIDE0VjEzSDE5LjVWMTMuNUgxOC41VjEwLjVIMTkuNVYxMUgyMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC4yNSAxMy41TDEzLjUgOUgxMkwxMyAxNUgxNS41TDE2LjUgOUgxNUwxNC4yNSAxMy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTggOVYxNUgxMS41VjEzLjVIOS41VjEyLjVIMTEuNVYxMUg5LjVWMTAuNUgxMS41VjlIOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hevc = createIcon('Hevc', [
  ['path', { d: 'M5.5 11H4.5V9H3V15H4.5V12.5H5.5V15H7V9H5.5V11Z', key: '1etwuw' }],
  [
    'path',
    {
      d: 'M21 11V10C21 9.45 20.55 9 20 9H18C17.45 9 17 9.45 17 10V14C17 14.55 17.45 15 18 15H20C20.55 15 21 14.55 21 14V13H19.5V13.5H18.5V10.5H19.5V11H21Z',
      key: 'evivg8',
    },
  ],
  ['path', { d: 'M14.25 13.5L13.5 9H12L13 15H15.5L16.5 9H15L14.25 13.5Z', key: '11cqcs' }],
  ['path', { d: 'M8 9V15H11.5V13.5H9.5V12.5H11.5V11H9.5V10.5H11.5V9H8Z', key: '1fct0j' }],
]);

export default Hevc;
